<template>
    <div class="background-base-popup">
        <transition name="popup-slide">
            <div class="base-popup" :style="{'--min-width': minWidth + '%'}">
                <div class="base-popup-header" v-if="$slots.header" :class="popupStyle">
                    <div class="base-popup-header-content">
                        <slot name="header"></slot>
                    </div>
                    <button @click="$emit('close')" class="close-button" v-show="!disabled">
                        <cancelIcon :style="{width: '15px', height: '15px'}"/>
                    </button>
                </div>
                <div class="base-popup-body">
                    <div class="base-popup-body-content" v-if="$slots.bodyContent">
                        <slot name="bodyContent">

                        </slot>
                    </div>
                    <div class="base-popup-body-grid" :style="{'--grid-size': gridSize + 'px'}" v-if="$slots.body">
                        <div v-for="(el, index) in media" :key="index">
                            <slot name="body" v-bind="{el, index}"></slot>
                        </div>
                    </div>
                </div>
                <div class="base-popup-footer" v-if="$slots.footer">
                    <slot name="footer">

                    </slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import cancelIcon from "../../IconComponents/cancelIcon.vue"

export default {
    name: "BasePopup",
    props: {
        popupStyle: {
            type: String,
            default: ""
        },
        media: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        gridSize: {
            type: Number,
            default: 150
        },
        minWidth: {
            type: Number,
            default: 33
        }
    },
    components: {
        cancelIcon
    },
    computed: {
        gridSize() {
            return this.gridSize || 150;
        },
        minWidth() {
            return this.minWidth || 33;
        }
    }
}
</script>

<style scoped>

.background-base-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5%;
}

.base-popup-body-content {
    margin: 0;
    color: #fff;
    font-size: 1.25rem;
    font-weight: 600;
    text-align: center;
    display: flex;
    justify-content: center;
    height: 100%;
}

.base-popup {
    --min-width: 33%;
    background-color: #1f2937;
    border-radius: .5rem;
    box-shadow: 0 0 20px #00000080;
    border: 1px solid rgba(255,255,255,.1);
    min-width: var(--min-width);
    max-width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
}

.base-popup-header {
    flex: 0 0 73px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: #3b82f61a;
    border-bottom: 1px solid rgba(59,130,246,.2);
    gap: 25px;
}

.base-popup-header.alert {
    background-color: #dc26261a;
    border-bottom: 1px solid rgba(220,38,38,.2);
}

.base-popup-header-content {
    margin: 0;
    color: #3b82f6;
    font-size: 1.25rem;
    font-weight: 600;
}

.alert .base-popup-header-content {
    color: #dc2626;
}

.base-popup-footer {
    flex: 0 0 73px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: #3b82f61a;
    border-top: 1px solid rgba(59,130,246,.2);
}

.base-popup-body {
    flex: 1;
    overflow-y: auto;
    padding: 1.5rem;
}

.base-popup-body-grid {
    --grid-size: 150px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(var(--grid-size), 1fr));
    gap: 1rem;
}

/* Animation de transition pour l'arrivée par le haut */
.popup-slide-enter-active {
    transition: all 0.3s ease-out;
}

.popup-slide-leave-active {
    transition: all 0.2s ease-in;
}

.popup-slide-enter-from {
    opacity: 0;
    transform: translateY(-30px);
}

.popup-slide-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

</style>